// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/Users/zhousicheng/workplace/SJrecords/frontend/music-admin/myapp/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import BookFilled from '/Users/zhousicheng/workplace/SJrecords/frontend/music-admin/myapp/node_modules/@ant-design/icons/es/icons/BookFilled';
import FormOutlined from '/Users/zhousicheng/workplace/SJrecords/frontend/music-admin/myapp/node_modules/@ant-design/icons/es/icons/FormOutlined';
import UnorderedListOutlined from '/Users/zhousicheng/workplace/SJrecords/frontend/music-admin/myapp/node_modules/@ant-design/icons/es/icons/UnorderedListOutlined';
export default { SmileOutlined, BookFilled, FormOutlined, UnorderedListOutlined };
